<template>
  <div class="car-item car-services" v-if="selectedServices.length > 0">
    <span class="car-icon"></span>
    <span class="car-text">
      {{$t('offer.selectedServicesTitle')}}
    </span>
    <ul>
      <li v-for="(service, index) in selectedServices" :key="index">
        {{ service | optionTranslate }}
      </li>
    </ul>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'SelectedServicesTile',
  computed: {
    ...mapGetters('vehicleServices', ['selectedServices'])
  }
}
</script>
